export default __webpack_public_path__ + "static/media/poster_420x594mm.c1eefd87.png";